export const POPULAR_CARRIERS_BY_INSURANCE_TYPE_STATE_KEY = 'popularCarriersByInsuranceType';
